import { render, staticRenderFns } from "./Blank.vue?vue&type=template&id=0bde8619&scoped=true&"
var script = {}
import style0 from "./Blank.vue?vue&type=style&index=0&id=0bde8619&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bde8619",
  null
  
)

export default component.exports